export class CallOverBankDetails {
    bankAccountNo: string;
    accountHolderName: string;
    bankName: string;
    bankBranch: string;
    swiftCode: string;

    constructor(bankAccountNo: string, accountHolderName: string, bankName: string, bankBranch: string, swiftCode: string) {
      this.bankAccountNo = bankAccountNo;
      this.accountHolderName = accountHolderName;
      this.bankName = bankName;
      this.bankBranch = bankBranch;
      this.swiftCode = swiftCode;
  }
  }
  